import { render, staticRenderFns } from "./lt-label.vue?vue&type=template&id=23ceb1f3&scoped=true"
import script from "./lt-label.vue?vue&type=script&lang=js"
export * from "./lt-label.vue?vue&type=script&lang=js"
import style0 from "./lt-label.vue?vue&type=style&index=0&id=23ceb1f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ceb1f3",
  null
  
)

export default component.exports